import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AddClientPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Navigate to clients page and trigger the add company dialog
    if (user?.username) {
      navigate(`/admin/${user.username}/clients?openAddCompanyDialog=true`);
    }
  }, [navigate, user]);
  
  return null; // This component doesn't render anything
};

export default AddClientPage;
